import { mainApi } from 'services/mainApi'
import { ReadChangeLogsParamsModel, ReadPropertySpyByIdModel, ReadPropertySpyListParamsModel, SetChangesViewedParamsModel, StartSpyHostServiceParamsModel } from './types'
import { getAdditionParameterListFromQueryParameterList } from 'shared/lib/getAdditionParameterListFromQueryParameterList'
import { getUrlStringFromAdditionParameterList } from 'shared/lib/getUrlStringFromAdditionParameterList'

export const propertySpyApi = mainApi
    .enhanceEndpoints({
        addTagTypes:[]
    })
    .injectEndpoints({
        endpoints: (builder) => ({
        readPropertySpyList: builder
            .query({
                query: (params?: ReadPropertySpyListParamsModel) => {
                    let url = `/propspies`
                    //const additionalParams: any[] = []
                    const additionalParams: any[] = getAdditionParameterListFromQueryParameterList(params)
                    // if (params?.pagination) {
                    //     const skip: number = params.pagination.page * params.pagination.pageSize;
                    //     const take: number = params.pagination.pageSize;

                    //     additionalParams.push({
                    //         name: 'skip',
                    //         value: skip
                    //     })

                    //     additionalParams.push({
                    //         name: 'take',
                    //         value: take
                    //     })
                    // }

                    // if (params?.locationsIds !== undefined){
                    //     additionalParams.push({
                    //         name: 'locationsIds',

                    //     })
                    // }

                    if (additionalParams.length > 0) {
                        const paramsString: string = additionalParams
                            .map((additionalParam) => {
                                if (Array.isArray(additionalParam.value)) {
                                    return additionalParam.value.map((item: any) => `${additionalParam.name}=${item}`).join('&');
                                }


                                return `${additionalParam.name}=${additionalParam.value}`;
                            })
                            .join('&');

                        url = `${url}?${paramsString}`
                    }

                    return url;
                },
                providesTags: (result) => result
                    ? [
                        ...result.list.map(({ id }: any) => ({ type: 'PropertySpy', id })),
                        { type: 'PropertySpy', id: 'LIST' },
                    ]
                    : [
                        { type: 'PropertySpy', id: 'LIST' }
                    ],
            }),
        readPropertySpyById: builder
            .query({
                query: (params: ReadPropertySpyByIdModel) => {
                    let url = `/propspies/${params.propertySpyId}`;

                    return url;
                },
            }),
        setChangesViewed: builder
            .mutation({
                query: ({ hostServiceId }: SetChangesViewedParamsModel) => ({
                    url: `/propspies/${hostServiceId}/setviewed`,
                    method: 'GET',
                }),
                invalidatesTags: [
                    {
                        type: 'PropertySpy',
                        id: 'LIST'
                    },
                ]
            }),
        startSpyHostService: builder
            .mutation({
                query: ({ hostServiceId, marketSpyId }: StartSpyHostServiceParamsModel) => ({
                    url: `/hostservices/${hostServiceId}/startspy?monitorId=${marketSpyId}`,
                    method: 'GET',
                }),
                invalidatesTags: [
                    {
                        type: 'PropertySpy',
                        id: 'LIST'
                    },
                    {
                        type: 'HostServices',
                        id: 'LIST'
                    },
                ]
            }),
        stopSpyHostService: builder
            .mutation({
                query: ({ hostServiceId, marketSpyId }: StartSpyHostServiceParamsModel) => ({
                    url: `/hostservices/${hostServiceId}/stopspy?monitorId=${marketSpyId}`,
                    method: 'GET',
                }),
                invalidatesTags: [
                    {
                        type: 'PropertySpy',
                        id: 'LIST'
                    },
                    {
                        type: 'HostServices',
                        id: 'LIST'
                    },
                ]
            }),
        readChangeLogs: builder
            .query({
                query: (params: any) => {
                    let url = `/propspies/${params.propertySpyId}/changelogs`
                    const additionalParams: any[] = getAdditionParameterListFromQueryParameterList(params)
                    if (additionalParams.length === 0){
                        return url
                    }

                    const paramsString = getUrlStringFromAdditionParameterList(additionalParams)
                    return `${url}?${paramsString}`;
                },
            }),
    }),
})

export const {  
    useReadPropertySpyListQuery,
    useReadPropertySpyByIdQuery,
    useLazyReadPropertySpyByIdQuery,
    useStartSpyHostServiceMutation,
    useStopSpyHostServiceMutation,
    useSetChangesViewedMutation,
    useReadChangeLogsQuery,
} = propertySpyApi
